module.exports = __webpack_public_path__ + "static/media/Draven.1c65e755.png";